

export const color = 'hoodle';
export const colorHex = "#54A4FB"

export const focusOutline = 'focus:outline-hoodle-600'
export const checkedBorder = 'checked:border-hoodle-600';
export const checkedBg = 'checked:bg-hoodle-600';
export const indeterminateBorder = 'indeterminate:border-hoodle-600';
export const indeterminateBg = 'indeterminate:bg-hoodle-600';
export const textColor = 'text-hoodle-600';
export const hoverTextColor = 'hover:text-hoodle-400';
export const groupHoverTextColor = 'group-hover:text-hoodle-500';
export const bgColor = 'bg-hoodle-600';
export const groupHoverBgColor = 'group-hover:bg-hoodle-500';
export const hoverBgColor = 'hover:bg-hoodle-500';
export const focusVisible = 'focus-visible:outline-hoodle-600';
export const disabledBg = 'disabled:bg-hoodle-300';
export const borderColor = 'border-hoodle-500';
export const dataFocusOutline = 'data-[focus]:bg-hoodle-600';
export const hasCheckedBgColor = 'has-[:checked]:bg-hoodle-600';

export const classNames = (...classes) => {
    return classes.filter(Boolean).join(' ')
}